var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dropdown",
    {
      attrs: { trigger: "click" },
      on: { "visible-change": _vm.dropdownClose }
    },
    [
      _c(
        "el-tooltip",
        {
          attrs: {
            effect: "dark",
            content: "Pesquisa Geral",
            placement: "bottom"
          }
        },
        [_c("i", { staticClass: "fal fa-search icone" })]
      ),
      _c(
        "el-dropdown-menu",
        {
          staticClass: "drop-down-menu",
          attrs: { slot: "dropdown" },
          slot: "dropdown"
        },
        [
          _c("div", { staticClass: "drop-down-text" }, [
            _c("strong", [_vm._v("Pesquisa rápida")]),
            _c(
              "label",
              [
                _c("span", { staticClass: "drop-down-text" }, [
                  _vm._v(
                    "Buscar pelo número de processo ou nome do interessado"
                  )
                ]),
                _c("filtro", {
                  attrs: {
                    configuracaoFiltro: _vm.configuracaoFiltro,
                    showPesquisaAvancada: false,
                    placeholder: "",
                    limparCampo: _vm.limparCampo,
                    campoSimplesObrigatorio: true,
                    pesquisaGeral: true,
                    naoInicializarInformacoesCaixa: true
                  },
                  on: {
                    pesquisar: _vm.pesquisarAppGeral,
                    limpar: _vm.limparPesquisaGeral
                  }
                })
              ],
              1
            ),
            _vm.totalElements > 0 && _vm.jaPesquisou
              ? _c("span", { staticClass: "encontrados" }, [
                  _vm._v(
                    _vm._s(_vm.totalElements) + " - processos encontrados!"
                  )
                ])
              : _vm._e(),
            _vm.totalElements === 0 && _vm.jaPesquisou
              ? _c("span", { staticClass: "encontrados" }, [
                  _vm._v("Nenhum processo encontrado.")
                ])
              : _vm._e()
          ]),
          _vm._l(_vm.processos, function(processo, index) {
            return _vm.processos
              ? _c(
                  "el-dropdown-item",
                  { key: processo.id, staticClass: "drop-down-item" },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "processo",
                        on: {
                          click: function($event) {
                            return _vm.irParaCaixaDoProcesso(
                              processo.caixa,
                              processo.numeroProcesso
                            )
                          }
                        }
                      },
                      [
                        _c("div", [
                          _c("span", [
                            _vm._v("Nome/Razão social do interessado:"),
                            _c("strong", [
                              _vm._v(
                                _vm._s(processo.nomeRazaoSocialInteressado)
                              )
                            ])
                          ])
                        ]),
                        _c("div", [
                          _c("span", [
                            _vm._v("CPF/CNPJ do interessado:"),
                            _c("strong", [
                              _vm._v(_vm._s(processo.cpfCnpjInteressado))
                            ])
                          ])
                        ]),
                        _c("div", [
                          _c("span", [
                            _vm._v("Situação:"),
                            _c("strong", [_vm._v(_vm._s(processo.status))])
                          ])
                        ])
                      ]
                    )
                  ]
                )
              : _vm._e()
          }),
          _vm.processos.length > 1
            ? _c("div", { staticClass: "footer" }, [
                _vm.totalElements > 15 &&
                _vm.totalElements !== _vm.processos.length
                  ? _c("div", { staticClass: "load" }, [
                      !_vm.isLoading
                        ? _c("a", { on: { click: _vm.maisProcessos } }, [
                            _vm._v("carregar mais")
                          ])
                        : _c("i", { staticClass: "el-icon-loading" })
                    ])
                  : _c("div", { staticClass: "resposta-footer" }, [
                      _vm.totalElements <= 15 && _vm.jaPesquisou
                        ? _c("span", [_vm._v("Não há mais processos")])
                        : _vm.jaPesquisou
                        ? _c("span", [_vm._v("Não há processos")])
                        : _vm._e()
                    ])
              ])
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-210210e5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-210210e5","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/analise/components/AppPesquisaGeral.vue
// module id = null
// module chunks = 